import ProfileForm from "./profile-form";

export default ProfileForm;